var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePassIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.3399H20C20.5523 10.3399 21 10.7876 21 11.3399V21.3399C21 21.8922 20.5523 22.3399 20 22.3399H4C3.44772 22.3399 3 21.8922 3 21.3399V11.3399C3 10.7876 3.44772 10.3399 4 10.3399H5V9.3399C5 5.47391 8.13401 2.3399 12 2.3399C15.866 2.3399 19 5.47391 19 9.3399V10.3399ZM5 12.3399V20.3399H19V12.3399H5ZM11 14.3399H13V18.3399H11V14.3399ZM17 10.3399V9.3399C17 6.57848 14.7614 4.3399 12 4.3399C9.23858 4.3399 7 6.57848 7 9.3399V10.3399H17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassIcon);
export default __webpack_public_path__ + "static/media/change-pass-icon.74e72e1e1ea3ca951cbbb67c6b989ed2.svg";
export { ForwardRef as ReactComponent };